import React, {useState} from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';

import { withRouter } from "react-router";

import {Copyright} from '../../../components';

import { useFormik } from 'formik';

import {initResetPassword} from '../../../services/auth.service';
import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";
import LoaderWithBackDrop from "../../../components/LoaderWithBackDrop/LoaderWithBackDrop.comp";
import {toast} from "../../../utils/utils";
import {TOAST_TYPES} from "../../../utils/constants";

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

const InitPasswordReset = (props) => {
    const classes = useStyles();

    const [loading, setLoading] = useState(false);

    const formik = useFormik({
        initialValues: {
            email: ''
        },
        onSubmit: async (values) => {
            console.log('Form data => ', values);
            try {
                const result = await initResetPassword(values.email);
                console.log('result.data -> ', result.data);
                // redirect to login page here
                toast(TOAST_TYPES.SUCCESS, "Token Sent", "Successfully Emailed the reset-token")
                props.history.push('/auth/reset/password');
            } catch (e) {
                // already toasted the error
            }
        }
    });

    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline />
            <div className={classes.paper}>
                <Avatar className={classes.avatar}>
                    <LockOutlinedIcon />
                </Avatar>
                <Typography component="h1" variant="h5">
                    Request Password Reset
                </Typography>
                <form className={classes.form} noValidate onSubmit={formik.handleSubmit}>
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="email"
                        label="Email Address"
                        name="email"
                        autoComplete="email"
                        autoFocus
                        onChange={formik.handleChange}
                        value={formik.values.email}
                    />

                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                    >
                        Send Reset Code
                    </Button>

                    <Grid container>
                        <Grid item xs>
                            <Link href="/login" variant="body2">
                                Back to Login Page
                            </Link>
                        </Grid>
                        <Grid item>
                            <Link href="/auth/reset/password" variant="body2">
                                {"Already have received code?"}
                            </Link>
                        </Grid>
                    </Grid>

                </form>
            </div>
            <Box mt={8}>
                <Copyright />
            </Box>

            <LoaderWithBackDrop loading={loading} />

        </Container>
    );
}

export default withRouter(InitPasswordReset);